/**
 * Mark columns and rows of grid items
 */

import $ from 'cash-dom';

const byNumber = (a, b) => a - b;
const selectFrom = obj => key => obj[key];
const isVisible = el => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

/**
 * Gather rows and columns from elements' offset
 */
export default function (el, options = {}) {
  const $items = $(options.matching || el.children, el);
  const t = {};

  $items.get().filter(isVisible).forEach((e) => {
    const top = Math.round(e.getBoundingClientRect().top);
    (t[top] || (t[top] = [])).push(e);
  });

  const rows = Object.keys(t).map(Number).sort(byNumber).map(selectFrom(t));

  return rows.map((row) => {
    const l = {};
    row.forEach((e) => {
      const left = Math.round(e.getBoundingClientRect().left);
      (l[left] || (l[left] = [])).push(e);
    });
    return Object.keys(l).map(Number).sort(byNumber).map(selectFrom(l));
  });
}
